import React from "react";
import "./AboutOurHelp.css";

function AboutOurHelp(props) {
  return (
    <div className="AboutOurHelp">
      <div id="about__ourhelp_container" className="about__ourhelp_container">
        <div className="about__ourhelp_descriptioncontainer ">
          <div
            id="ourhelp_descriptioncontainer"
            className="ourhelp_descriptioncontainer slow__display"
          >
            <h2>How we help</h2>
            <p>
              In partnership with the Love Trust we provide a holistic,
              contextual approach to developing OVC leaders so they can care for
              vulnerable children and their families in impoverished
              communities. The name ChildVision describes the focus – children.
              ChildVision has been set up to create a safe and loving
              environment for extremely vulnerable children to be provided with
              the core basic needs such as nutrition, education, a nurturing
              community, the children’s families with a stable income, and a
              knowledge of God (and the hope that He provides) that children
              need to flourish. As Christians, we are called to care for the
              helpless. We can't care for everyone, but we can equip others to
              not only help themselves but also care for the helpless.
            </p>
          </div>
        </div>
        <div className="about__ourhelp_imgcontainer">
          <img id="ourhelp__img" src="/img/img-6.jpg" />
        </div>
        <div
          id="about__ourhelp_emptycontainer"
          className="about__ourhelp_emptycontainer opacity__display"
        ></div>
      </div>
    </div>
  );
}

export default AboutOurHelp;
